
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styles from '../../styles/home/investLiquiditySection.module.scss';
import MainButton from "../Button";
export default function InvestLiquiditySection() {
    return (<section className={styles.investLiquiditySection}>
        <div className={styles.container}>
          <div className={styles.textContainer}>
            <h2 className={styles.title}>
              Allocate capital to the HFDX
              <br /> Liquidity Provider Strategy
            </h2>

            <MainButton text={'Invest Now'}/>
          </div>

          <div className={styles.description}>
            <p>A professionally managed liquidity program designed to pursue 60%+ returns, operated alongside a veteran international trading group with 50+ years of proven expertise.</p>
          </div>
        </div>
        <div className={styles.videoBackground}>
          <video autoPlay loop muted playsInline className={'video'}>
            <source src="/videos/unicorn-1764859291889.mp4" type="video/mp4"/>
          </video>
        </div>
      </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f3cc__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//InvestLiquiditySection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f3cc__ as getStaticProps }
  